function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import i18n from 'invision-core/src/components/i18n/i18n';
import { UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { NewWindow } from 'invision-core';
import LocaleKeys from '../../../locales/keys';
import { FUTURE_INVOICE_CALCULATION_COMPLETION_STATUS, FUTURE_INVOICE_COLUMNDEFS, FUTURE_INVOICE_DETAILS_URL, FUTURE_INVOICE_REFRESH_TIMEOUT, FUTURE_INVOICE_START_CALCULATION_ACTIONS } from '../billing.payments.constants';
import { retrieveFutureInvoices } from '../../../reducers/actions/customer.billing.actions';
import { CurrentCustomerIdSelector } from '../../../reducers/selectors/customer.selectors';
import { FutureInvoicesCalculationSessionIdSelector, FutureInvoicesCalculationStatusSelector, FutureInvoicesDataSelector, IsFutureInvoicesCalcultaionStartedSelector } from '../../../reducers/selectors/customer.billing.futureStatements.selectors';
var BillingFutureInvoicesController = /*#__PURE__*/function () {
  function BillingFutureInvoicesController($ngRedux, $state, $timeout, uiNotificationService, $interval) {
    _classCallCheck(this, BillingFutureInvoicesController);
    Object.assign(this, {
      $interval: $interval,
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      fetchFutureInvoices: this.fetchFutureInvoices.bind(this),
      FUTURE_INVOICE_CALCULATION_COMPLETION_STATUS: FUTURE_INVOICE_CALCULATION_COMPLETION_STATUS,
      FUTURE_INVOICE_COLUMNDEFS: FUTURE_INVOICE_COLUMNDEFS,
      FUTURE_INVOICE_START_CALCULATION_ACTIONS: FUTURE_INVOICE_START_CALCULATION_ACTIONS,
      LocaleKeys: LocaleKeys,
      openInvoiceInNewWindow: this.openInvoiceInNewWindow.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(BillingFutureInvoicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          futureInvoicesCalculationSessionId: FutureInvoicesCalculationSessionIdSelector(store),
          futureInvoicesCalculationStatus: FutureInvoicesCalculationStatusSelector(store),
          futureInvoicesData: FutureInvoicesDataSelector(store),
          isFutureInvoicesCalcultaionStartedselector: IsFutureInvoicesCalcultaionStartedSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store)
        };
      };
      var controllerActions = {
        retrieveFutureInvoices: retrieveFutureInvoices
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.fetchFutureInvoices();
    }
  }, {
    key: "fetchFutureInvoices",
    value: function fetchFutureInvoices(isGenerateNewInvoices) {
      var _this2 = this;
      var FUTURE_STATEMENTS_REQUEST_PAYLOAD = {};
      FUTURE_STATEMENTS_REQUEST_PAYLOAD.Action = !isGenerateNewInvoices ? this.FUTURE_INVOICE_START_CALCULATION_ACTIONS.CHECK_STATUS_OR_START : this.FUTURE_INVOICE_START_CALCULATION_ACTIONS.START_CALCULATION;
      this.futureInvoicesAreReady = false;
      if (this.state.futureInvoicesCalculationSessionId && !isGenerateNewInvoices) {
        FUTURE_STATEMENTS_REQUEST_PAYLOAD.CalculationSessionId = this.state.futureInvoicesCalculationSessionId;
      }
      if (this.intervalObj) {
        this.$interval.cancel(this.intervalObj);
      }
      this.actions.retrieveFutureInvoices(FUTURE_STATEMENTS_REQUEST_PAYLOAD, this.state.currentCustomerId).then(function () {
        if (_this2.state.futureInvoicesCalculationStatus !== _this2.FUTURE_INVOICE_CALCULATION_COMPLETION_STATUS.READY) {
          _this2.triggerRefreshTimer();
        } else {
          _this2.futureInvoicesAreReady = true;
        }
      }).catch(function (error) {
        _this2.triggerRefreshTimer();
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "triggerRefreshTimer",
    value: function triggerRefreshTimer() {
      var _this3 = this;
      this.remainingSecond = FUTURE_INVOICE_REFRESH_TIMEOUT;
      this.leftOverSecond = "".concat(this.remainingSecond, " ").concat(i18n.translate(this.LocaleKeys.SECONDS));
      this.intervalObj = this.$interval(function () {
        _this3.remainingSecond = _this3.remainingSecond - 1;
        _this3.leftOverSecond = "".concat(_this3.remainingSecond, " ").concat(i18n.translate(_this3.LocaleKeys.SECONDS));
        if (!_this3.remainingSecond) {
          _this3.fetchFutureInvoices();
        }
      }, 1000);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
      this.$interval.cancel(this.intervalObj);
    }
  }, {
    key: "openInvoiceInNewWindow",
    value: function openInvoiceInNewWindow(invoiceId) {
      NewWindow.open(FUTURE_INVOICE_DETAILS_URL, {
        invoiceId: invoiceId
      });
    }
  }]);
}();
export default {
  controller: BillingFutureInvoicesController,
  controllerAs: 'BillingFutureInvoicesController',
  template: require('./billing.future.invoices.template.html')
};